import ActionTypes from "../const/ActionTypes"

export function saveProgram (program) {
  return {
    type: ActionTypes.PROGRAM_SAVE,
    payload: {
      program
    }
  }
}

export function loadProgram (program) {
  return {
    type: ActionTypes.PROGRAM_LOAD,
    payload: {
      program
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/drawings.js